import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthDialogService {
  private showLoginSubject = new Subject<void>();
  showLogin$ = this.showLoginSubject.asObservable();

  openLogin() {
    this.showLoginSubject.next();
  }
}
